module.exports = __webpack_public_path__ + "static/germany-6fcfe035ec6baac908c63d1f9a58b2a8.jpg";